import Admin from "../Admin";
import React from "react";
import CardAdminInsuranceTypeList from "../../../Component/Card/Admin/InsuranceType/CardAdminInsuranceTypeList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class InsuranceTypeList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminInsuranceTypeList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/insuranceType",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Payor Sources" buttons={buttons} />;
  }
}
